// @ts-nocheck
import * as React from 'react';
import * as ReactDom from 'react-dom';
import $ from 'jquery';
import OxygenWarning from '../../images/OxygenWarning.jpg';
export class ConfirmationWindow extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    yes() {
        this.props.OkMethod();
    }

    no() {
        this.props.cancelMethod();
    }

    closePopUp() {
        $("#confirmPopUpModel").hide();
        $("#modal-backdrop-confirmation").removeClass("show");
        $("#modal-backdrop-confirmation").addClass("hide");
    }

    public render() {
        return <div>
           
            <div className='modal-backdrop opacity-50' id='modal-backdrop-confirmation'></div>
            <div className="modal" id="confirmPopUpModel" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation </h5>
                            <button type="button" className="btn-close" onClick={this.closePopUp.bind(this)}>&times;</button>
                        </div>
                        <div className="modal-body">
                            {
                                this.props.showWarning ?
                                    <div>
                                        <div className="row">
                                            <div className='col-md-12'>
                                                <div className='text-justify'>
                                                    <img src={OxygenWarning} width="250" height="50" className='img-responsive ml-158' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className='col-md-12'>
                                                <div className='text-justify mt-2' dangerouslySetInnerHTML={{ __html: this.props.Message }}>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div dangerouslySetInnerHTML={{ __html: this.props.Message }}>
                                    </div>
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="hidePopUpBtn" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.no.bind(this)}>No</button>
                            <button type="button" id="btnYes" className="btn btn-primary" onClick={this.yes.bind(this)}>Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export class ConfirmationWindowOK extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    yes() {
        this.props.OkMethod();
    }

    closePopUp() {
        $("#confirmPopUpModel").hide();
        $("#modal-backdrop-confirmation").removeClass("show");
        $("#modal-backdrop-confirmation").addClass("hide");
    }

    public render() {
        return <div>
           
            <div className='modal-backdrop opacity-50' id='modal-backdrop-confirmation'></div>
            <div className="modal" id="confirmPopUpModel" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.props.Title} </h5>
                            <button type="button" className="btn-close" onClick={this.closePopUp.bind(this)}>&times;</button>
                        </div>
                        <div className="modal-body">
                            {
                                this.props.showWarning ?
                                    <div>
                                        <div className="row">
                                            <div className='col-md-12'>
                                                <div className='text-justify'>
                                                    <img src={OxygenWarning} width="250" height="50" className='img-responsive ml-158' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className='col-md-12'>
                                                <div className='text-justify mt-2' dangerouslySetInnerHTML={{ __html: this.props.Message }}>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div dangerouslySetInnerHTML={{ __html: this.props.Message }}>
                                    </div>
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="btnYes" className="btn btn-primary" onClick={this.yes.bind(this)}>OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export class ConfirmWindow extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }
    static close() {
        $("#confirmPopUpModel .btn-close").click();
    }
    static showConfirmBox(Message, OkMethod, cancelMethod) {
        //debugger
        //if ($('#add-here').is(':empty'))
        //    ReactDom.render(<ConfirmationWindow Message='confirmation message' />, $('#add-here')[0]);
        //else
        //    ReactDom.unmountComponentAtNode($('#add-here')[0]);
        //$('#divMsboxDynamicContent').empty();
        ReactDom.render(<ConfirmationWindow Message={Message} OkMethod={OkMethod} cancelMethod={cancelMethod} />, document.getElementById('divMsboxDynamicContent'));
        setTimeout(function () {
            $("#modal-backdrop-confirmation").removeClass("hide");
            $("#modal-backdrop-confirmation").addClass("show");
            $('#confirmPopUpModel').show();
          
        }, 50);
    }
          
    static showGeofenceConfirmBox(Message, OkMethod, cancelMethod) {
        //debugger
        //if ($('#add-here').is(':empty'))
        //    ReactDom.render(<ConfirmationWindow Message='confirmation message' />, $('#add-here')[0]);
        //else
        //    ReactDom.unmountComponentAtNode($('#add-here')[0]);
        //$('#divMsboxDynamicContent').empty();
        ReactDom.render(<ConfirmationWindow Message={Message} OkMethod={OkMethod} cancelMethod={cancelMethod} cssClass={"geofencePopup"}/>, document.getElementById('divMsboxDynamicContent'));
        setTimeout(function () {
            $("#modal-backdrop-confirmation").removeClass("hide");
            $("#modal-backdrop-confirmation").addClass("show");
            $('#confirmPopUpModel').show();
        }, 50);
    }

    static showConfirmBoxwith3options(Message, BookingLevel, ReeferLevel, cancelMethod) {
        //debugger
        //if ($('#add-here').is(':empty'))
        //    ReactDom.render(<ConfirmationWindow Message='confirmation message' />, $('#add-here')[0]);
        //else
        //    ReactDom.unmountComponentAtNode($('#add-here')[0]);
        //$('#divMsboxDynamicContent').empty();
        ReactDom.render(<ConfirmationWindowwith3options Message={Message} BookingLevel={BookingLevel} ReeferLevel={ReeferLevel} cancelMethod={cancelMethod} />, document.getElementById('divMsboxDynamicContent'));
        setTimeout(function () {
            $("#modal-backdrop-confirmation").removeClass("hide");
            $("#modal-backdrop-confirmation").addClass("show");
            $('#confirmPopUpModel').show();
        }, 50);
    }
    static showConfirmBoxOK(Title, Message, OkMethod) {

        ReactDom.render(<ConfirmationWindowOK Title={Title} Message={Message} OkMethod={OkMethod} />, document.getElementById('divMsboxDynamicContent'));
        setTimeout(function () {
            $("#modal-backdrop-confirmation").removeClass("hide");
            $("#modal-backdrop-confirmation").addClass("show");
            $('#confirmPopUpModel').show();
        }, 50);
    }

    static showConfirmBoxWithWarning(Message, OkMethod, cancelMethod) {
        ReactDom.render(<ConfirmationWindow Message={Message} showWarning={true} OkMethod={OkMethod} cancelMethod={cancelMethod} />, document.getElementById('divMsboxDynamicContent'));
        setTimeout(function () {
            $("#modal-backdrop-confirmation").removeClass("hide");
            $("#modal-backdrop-confirmation").addClass("show");
            $('#confirmPopUpModel').show();
        }, 50);
    }

    public render() {
        return <div >
        </div>
    }
}
export class ConfirmationWindowwith3options extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    BookingLevel() {
        this.props.BookingLevel();
    }

    ReeferLevel() {
        this.props.ReeferLevel();
    }
    No() {
        this.props.cancelMethod();
    }
    closePopUp() {
        $("#confirmPopUpModel").hide();
        $("#modal-backdrop-confirmation").removeClass("show");
        $("#modal-backdrop-confirmation").addClass("hide");
    }

    public render() {
        return <div>
            <div className='modal-backdrop opacity-50' id='modal-backdrop-confirmation'></div>
           
            <div className="modal" id="confirmPopUpModel" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation </h5>
                            <button type="button" className="btn-close" onClick={this.closePopUp.bind(this)}>&times;</button>
                        </div>
                        <div className="modal-body">
                            {
                                this.props.showWarning ?
                                    <div>
                                        <div className="row">
                                            <div className='col-md-12'>
                                                <div className='text-justify'>
                                                    <img src={OxygenWarning} width="250" height="50" className='img-responsive ml-158' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className='col-md-12'>
                                                <div className='text-justify mt-2' dangerouslySetInnerHTML={{ __html: this.props.Message }}>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div dangerouslySetInnerHTML={{ __html: this.props.Message }}>
                                    </div>
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="hidePopUpBtn" className="btn btn-primary" data-bs-dismiss="modal" onClick={this.No.bind(this)}>Cancel</button>
                            <button type="button" id="btnYes" className="btn btn-secondary" onClick={this.BookingLevel.bind(this)}>All Reefers</button>
                            <button type="button" id="hidePopUpBtn" className="btn btn-secondary" onClick={this.ReeferLevel.bind(this)}>Selected Reefer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}